document.addEventListener("turbo:load", function() {
    $('.toast').toast("show");

    if(typeof tinymce != "undefined") {
        tinymce.remove();
        tinymce.init({ selector: ".tinymce" });
    }

    Prism.highlightAll();

    // Like button
    document.addEventListener('click', function(e) {
        var btn = e.target.closest('.blog-like-btn');
        if (!btn) return;
        if (btn.classList.contains('blog-like-btn--liked')) return;

        var url = btn.dataset.likesUrl;
        var csrf = document.querySelector('meta[name="csrf-token"]').content;

        fetch(url, {
            method: 'POST',
            headers: { 'X-CSRF-Token': csrf, 'Accept': 'application/json' }
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
            btn.querySelector('.likes-counter').textContent = data.likes;
            btn.classList.add('blog-like-btn--liked');
        });
    });

    // Search overlay
    var overlay = document.getElementById('searchOverlay');
    var input   = document.getElementById('searchInput');
    var openBtn = document.getElementById('searchOpen');
    var closeBtn = document.getElementById('searchClose');

    if (!overlay) return;

    function openSearch() {
        overlay.classList.add('is-open');
        setTimeout(function() { input.focus(); }, 50);
        document.body.style.overflow = 'hidden';
    }

    function closeSearch() {
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
        input.value = '';
    }

    openBtn.addEventListener('click', openSearch);
    var openBtnMobile = document.getElementById('searchOpenMobile');
    if (openBtnMobile) openBtnMobile.addEventListener('click', openSearch);
    closeBtn.addEventListener('click', closeSearch);

    overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closeSearch();
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeSearch();
        if ((e.key === 'k' && (e.metaKey || e.ctrlKey))) {
            e.preventDefault();
            openSearch();
        }
    });
});
